export default __webpack_public_path__ + "static/logo_campfire_enjine-9ca8a5df55ffacf43f699bfefa17a62d.png";